import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  JobType,
  JobTypeColors,
  JobTypeIcons,
  JobTypeLabels,
} from "../../models/Jobs/JobType";

interface JobTypeChipProps {
  type: JobType;
}

const JobTypeChip: React.FC<JobTypeChipProps> = ({ type }) => {
  const Icon = JobTypeIcons[type];

  return (
    <Badge variant="outline" className="gap-1.5 text-muted-foreground">
      {Icon && <Icon className="size-3" />}
      {JobTypeLabels[type]}
    </Badge>
  );
};

export default JobTypeChip;
